import { IGroupInfo, IMessageListFilter } from "@home-health-notify/domain";
import { useTranslation } from "hhn-commons";
import { useState } from "react";
import { Divider, IconButton } from "@mui/material";
import { MessageFilterWrapper, SearchBoxWrapper } from "../GroupHeader.style";
import { SearchBox } from "../../../../common/SearchBox";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import GroupMessageSearchInput, { SenderType } from "./GroupMessageSearchInput";

export const GroupMessageSearch = ({
  groupInfo,
  onClearSearch,
  onFilter,
  fullWidth = false,
}: {
  groupInfo: IGroupInfo;
  onClearSearch: () => void;
  onFilter: (filters: IMessageListFilter) => void;
  fullWidth?: boolean;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const [searchText, setSearchText] = useState<string>("");
  const [filterRequest, setFilterRequest] = useState<IMessageListFilter>({});
  const [isSearchLoading, setSearchLoading] = useState<boolean>(false);
  const [selectedSenders, setSelectedSenders] = useState<SenderType[]>([]);

  const handleFilter = (filters: IMessageListFilter) => {
    setSearchLoading(true);
    onFilter(filters);
    setSearchLoading(false);
  };

  const onSearchTextChange = (searchText: string) => {
    setSearchText(searchText);
    const clonedChatListFilter: IMessageListFilter = {
      ...filterRequest,
      search: searchText,
    };
    setFilterRequest(clonedChatListFilter);
    handleFilter(clonedChatListFilter);
  };

  const onSearchClear = () => {
    setSearchText("");
    let clonedFilterRequest = { ...filterRequest };
    delete clonedFilterRequest["search"];
    setFilterRequest(clonedFilterRequest);
    if (clonedFilterRequest) {
      onFilter(clonedFilterRequest);
    } else {
      onClearSearch();
    }
  };

  const updateFilters = (value: SenderType[]) => {
    let clonedFilterRequest = { ...filterRequest };
    if (value.length > 0) {
      clonedFilterRequest["filterBySenderIds"] = value.map(
        userDetail => userDetail.id,
      );
    } else {
      delete clonedFilterRequest["filterBySenderIds"];
    }
    setFilterRequest(clonedFilterRequest);
    handleFilter(clonedFilterRequest);
  };

  const onClearFilters = (value: SenderType[]) => {
    setSelectedSenders(value);
    updateFilters(value);
  };

  const onInputChange = (value: SenderType[]) => {
    setSelectedSenders(value);
    updateFilters(value);
  };

  return (
    <SearchBoxWrapper
      data-testid="MessageSearchContainer"
      fullWidth={fullWidth}
    >
      <SearchBox
        placeholderLabel={tNs("search.placeholder")}
        searchText={searchText}
        onSearchClear={onSearchClear}
        onSearchTextChange={onSearchTextChange}
        isLoading={isSearchLoading}
      >
        <MessageFilterWrapper>
          <GroupMessageSearchInput
            groupInfo={groupInfo}
            onChange={onInputChange}
            onClearFilters={onClearFilters}
            selectedSenders={selectedSenders}
          />
          <Divider
            sx={{ height: 28, marginLeft: "8px" }}
            orientation="vertical"
          />
          <IconButton onClick={onClearSearch}>
            <SearchOffIcon data-testid="SearchOff" color={"primary"} />
          </IconButton>
        </MessageFilterWrapper>
      </SearchBox>
    </SearchBoxWrapper>
  );
};
